import { render, staticRenderFns } from "./RegisterPage3.vue?vue&type=template&id=360d9490&scoped=true&"
import script from "./RegisterPage3.vue?vue&type=script&lang=js&"
export * from "./RegisterPage3.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPage3.vue?vue&type=style&index=0&id=360d9490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360d9490",
  null
  
)

export default component.exports